__turbopack_context__.v({
  "stickyBuyButton": "MobileStickyBuyButton-module___fHSXa__stickyBuyButton",
});
